import { RowProps } from 'antd'
import React, { useEffect } from 'react'
import { useFormContext, useFormState } from 'react-hook-form'

type EditableRowProps = {
  index: number
  isSelected: boolean
  data: any
  onClickRow: (data: any) => void
} & RowProps
const EditableRow = React.forwardRef(function EditableRow(props: EditableRowProps, ref) {
  const { data, isSelected, onClickRow, children, ...rest } = props
  const { setValue } = useFormContext();
  const { errors } = useFormState()
  const valid = !errors?.tableList?.[data?.id];

  const handleOnClick = () => {
    onClickRow && onClickRow(data)
  }

  useEffect(() => {
    setValue(`tableList.${data?.id}.status`, valid ? 'valid': 'invalid');
  }, [valid])

  return (
    <tr
      {...rest}
      ref={ref}
      onClick={handleOnClick}
    >{children}</tr>
  )
})

function arePropsEqual(oldProps: EditableRowProps, newProps: EditableRowProps) {
  // console.log("🚀 ~ arePropsEqual ~ newProps:", newProps)
  // console.log("🚀 ~ arePropsEqual ~ oldProps:", oldProps)
  // console.log("🚀 ~ arePropsEqual", oldProps.index === newProps.index &&
  //     (oldProps.isSelected && newProps.isSelected) &&
  //     oldProps.className === newProps.className)
  return false
}

export default EditableRow
